import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = [".open"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { slot: "footer" }
const _hoisted_4 = ["disabled"]

import { ref } from 'vue';
import { useStore } from 'vuex';
import Banner from '@components/Banner/Banner.vue';
import { useDeleteBuilderImage } from '../../queries/useBuilderImagesMutations';
import { BuilderImage } from '../../models/builderimage/ui-types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageDeleteModal',
  emits: ['deleted'],
  setup(__props, { expose: __expose, emit: __emit }) {

const showDeleteModal = ref<boolean>(false);
const imageToDelete = ref<BuilderImage | null>(null);
const errors = ref<Array<string>>([]);
const hasAssociatedApps = ref<boolean>(false);

const store = useStore();
const t = store.getters['i18n/t'];

const {mutate: deleteBuilderImage, isPending: isDeletingBuilderImage, isError: deleteBuilderImageError, error: deleteBuilderImageErrorData} = useDeleteBuilderImage(store, handleSuccess);

function openDelete(row: BuilderImage) {
  imageToDelete.value = row;
  showDeleteModal.value = true;
  hasAssociatedApps.value = !!row.boundApps;
}

function closeDelete() {
    showDeleteModal.value = false;
    errors.value = [];
    hasAssociatedApps.value = false;
    imageToDelete.value = null;
}

async function onSubmitDelete() {
    if (!imageToDelete.value) {
        return;
    }
    const imageName = imageToDelete.value.meta.name;
    deleteBuilderImage({ name: imageName });
}

function handleSuccess() {
    store.dispatch('growl/success', {
        title:   t('epinio.growl.builderImages.delete.success.title'),
        message: t('epinio.growl.builderImages.delete.success.message', { name: imageToDelete.value?.meta.name }),
    });
    emit('deleted');
    closeDelete();
};
const emit = __emit;
__expose({
  openDelete
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-modal", {
    ".open": showDeleteModal.value,
    title: "Are you sure?",
    onModalClose: closeDelete
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createTextVNode("You are attempting to delete the Image ", -1)),
        _createElementVNode("strong", null, _toDisplayString(imageToDelete.value?.meta.name), 1),
        _cache[1] || (_cache[1] = _createTextVNode(".", -1))
      ]),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "Are you sure you want to proceed?", -1)),
      _cache[4] || (_cache[4] = _createTextVNode()),
      (hasAssociatedApps.value)
        ? (_openBlock(), _createBlock(Banner, {
            key: 0,
            color: "warning",
            label: "This image is currently associated with one or more applications. Deleting it will prevent future rebuilds."
          }))
        : _createCommentVNode("", true),
      _cache[5] || (_cache[5] = _createTextVNode()),
      (_unref(deleteBuilderImageError))
        ? (_openBlock(), _createBlock(Banner, {
            key: 1,
            color: "error",
            label: _unref(deleteBuilderImageErrorData)?.message || _unref(t)('epinio.builderImages.errors.delete')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("trailhand-button", {
        variant: "secondary",
        class: "mr-10",
        onButtonClick: closeDelete
      }, "Cancel", 32),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createElementVNode("trailhand-button", {
        disabled: _unref(isDeletingBuilderImage),
        variant: "destructive",
        onButtonClick: onSubmitDelete
      }, _toDisplayString(_unref(isDeletingBuilderImage) ? _unref(t)('generic.deleting') : _unref(t)('generic.delete')), 41, _hoisted_4)
    ])
  ], 40, _hoisted_1))
}
}

})